import styled from '@emotion/styled';
import { Button } from '@material-ui/core';

const StyledButton = styled(Button)({
  height: 40,
  '&.MuiButton-outlined': {
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'center',
    color: '#4C566C',
    background: '#FFFFFF',
    border: '1.5px solid #E6E7E8',
    borderRadius: 4,
  },
  '&.MuiButton-contained': {
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'center',
    color: '#FFFFFF',
    background: '#4C566C',
    border: '1.5px solid #4C566C',
    borderRadius: 4,
  },
});

export default StyledButton;
